export interface LoginAlert {
  severity: 'info' | 'success' | 'error' | 'warning' | undefined;
  message: string;
  dismissible: boolean;
}

export const LOGIN_ALERTS_KEY = 'loginAlerts';

export function popAlerts(): LoginAlert[] {
  const alertsJson = localStorage.getItem(LOGIN_ALERTS_KEY);
  localStorage.removeItem(LOGIN_ALERTS_KEY);

  if (!alertsJson) {
    return [];
  }

  let alerts: LoginAlert[] = [];

  try {
    alerts = JSON.parse(alertsJson) as LoginAlert[];
    // eslint-disable-next-line no-empty
  } catch (ex) {}

  if (!alerts) {
    return [];
  }

  return alerts;
}

export function pushAlert(alert: LoginAlert): void {
  let alerts = popAlerts();

  alerts.push(alert);

  alerts = alerts.filter(
    (alert, index) =>
      alerts.findIndex(
        (item) =>
          item &&
          alert &&
          item.severity === alert.severity &&
          item.message === alert.message &&
          item.dismissible === alert.dismissible
      ) === index
  );

  localStorage.setItem(LOGIN_ALERTS_KEY, JSON.stringify(alerts));
}
